import * as React from "react";
import classnames from "classnames";
/* empty css                      */
const ConfiguratorStep = ({
  children,
  className,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: classnames("configurator-step", className), "data-t": rest["data-t"] }, children);
};
export {
  ConfiguratorStep
};
//# sourceMappingURL=ConfiguratorStep.js.map
